import { render, staticRenderFns } from "./style_imports.vue?vue&type=template&id=173a558e&scoped=true&"
import script from "./style_imports.vue?vue&type=script&lang=js&"
export * from "./style_imports.vue?vue&type=script&lang=js&"
import style0 from "./style_imports.vue?vue&type=style&index=0&id=173a558e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a558e",
  null
  
)

export default component.exports